import { Form } from '@ui';
import styled from 'styled-components';

export const FormSC = styled(Form)`
  .ui-textfield {
    width: 100%;
  }
` as typeof Form;
